import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { RoiService } from '@smartflip/ui-utils';
import { FieldConfig } from '@smartflip/data-models';
import { carryFields } from '@smartflip/data-field-configuration';

@Component({
  selector: 'app-carrying-costs',
  templateUrl: './carrying-costs.component.html',
  styleUrls: ['./carrying-costs.component.scss'],
  standalone: false,
})
export class CarryingCostsComponent implements OnInit {
  public carryForm: UntypedFormGroup;
  fieldList: FieldConfig[];
  durationField: FieldConfig;

  calcMonthly(f) {
    return (
      (this.carryForm.value[f.name] || 0) / this.carryForm.value['duration']
    );
  }

  constructor(private roi: RoiService) {}

  ngOnInit() {
    this.durationField = carryFields.find((f) => f.name === 'duration') || null;
    this.fieldList = carryFields.filter((f) => f.name !== 'duration');
    // isolate the duration because it doesn't have a monthly/total setup
    this.carryForm = this.roi.formGroups['carry'];

    // Annual property tax total
    if (
      !this.carryForm.value['proptax'] ||
      this.carryForm.value['proptax'] === 0
    ) {
      const purchasePrice =
        this.roi.calculationValues?.['summary']?.['price'].value || 0;
      const newTax = purchasePrice * 0.02; // estimate at 2%
      this.carryForm.patchValue({ proptax: newTax });
    }
  }
}
